module.exports = __webpack_public_path__ + "static/media/xero-logo.d6e42429.svg";